import React from 'react';
import { IconAuto, IconPerformance, IconMoto } from '../icons/Icons';

interface VehicleTypeSelectorProps {
    vehicleType: 'auto' | 'moto' | 'performance';
    onCountryChange: (code: 'auto' | 'moto' | 'performance') => void;
}

const VehicleTypeSelector: React.FC<VehicleTypeSelectorProps> = ({ vehicleType, onCountryChange }) => {
    return (
        <div className="grid justify-center mb-[5px] grid-cols-3 gap-[5px]">
            <span title="Auto" className={`link-vehicle-type ${vehicleType === 'auto' ? 'active' : ''}`} onClick={() => onCountryChange('auto')} role="button">
                <IconAuto height="18px" /></span>
            <span title="Performance" className={`link-vehicle-type ${vehicleType === 'performance' ? 'active' : ''}`} onClick={() => onCountryChange('performance')} role="button">
                <IconPerformance  height="18px"  /></span>
            <span title="Moto" className={`link-vehicle-type ${vehicleType === 'moto' ? 'active' : ''}`} onClick={() => onCountryChange('moto')} role="button">
                <IconMoto  height="21px"  /></span>
        </div>
    );
};

export default VehicleTypeSelector;